import { useEffect, useState } from "react";
import CampIcon from "../pages/pc/CampIcon";

const ChildCampIcon = ({ childId }) => {
  const [camp, setCamp] = useState(null);

  useEffect(() => {
    if (!"https://4c.gaxil.eu" || !childId) return;

    const controller = new AbortController();
    fetch(new URL(`/children/${childId}`, "https://4c.gaxil.eu").href, {
      signal: controller.signal,
    })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data?.camp) setCamp(data.camp);
      })
      .catch(() => {});

    return () => controller.abort();
  }, [childId]);

  if (!camp) return null;

  const campObject = typeof camp === "string" ? { shortcut: camp, name: camp } : camp;

  return (
    <span className="relative top-[3px] ml-1 inline-flex">
      <CampIcon camp={campObject} size={18} withTooltip={false} />
    </span>
  );
};

export default ChildCampIcon;
